import backend from "../utils/backend";
import selectn from "selectn";
import * as actionTypes from "../constants/actionTypes";

export const getSections = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_SECTIONS,
    });

    return backend.request({
      method: "GET",
      url: "/sections/",
    })
      .then((response) => {
        dispatch({
          type: actionTypes.GET_SECTIONS_SUCCESS,
          payload: response.data.results,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.GET_SECTIONS_ERROR,
          payload: err,
        });
      });
  };
};

export const getSection = (slug) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_SECTION,
    });

    return backend.request({
      method: "GET",
      url: `/sections/${slug}/`,
    })
      .then((response) => {
        dispatch({
          type: actionTypes.GET_SECTION_SUCCESS,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.GET_SECTION_ERROR,
          payload: err,
        });
      });
  };
};

export const setSection = (section) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_SECTION,
      section,
    });
  };
};

export const setLastSeen = (lastSeen) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_LAST_SEEN,
      lastSeen,
    });
  };
};

export const getSpecialFeatures = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_SPECIAL_FEATURES,
    });

    return backend.request({
      method: "GET",
      url: "/special-features/",
    })
      .then((response) => {
        dispatch({
          type: actionTypes.GET_SPECIAL_FEATURES_SUCCESS,
          payload: response.data.results,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.GET_SPECIAL_FEATURES_ERROR,
          payload: err,
        });
      });
  };
};

export const setSectionWithTag = (tag) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_TAG,
    });

    return backend.request({
      method: "GET",
      url: `/tag/${tag}/`,
    })
      .then((response) => dispatch(setSection({ slug: tag, name: selectn("data.name", response) })))
      .catch((err) => {
        dispatch({
          type: actionTypes.GET_TAG_ERROR,
          payload: err,
        });
      });
  };
};
